import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DEVICE_TYPE } from "../../constants";
import { RoutesPaths } from "../../Router/constant";

export default function MyInfo() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector(state => state.auth);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (location.search) {
      const code = queryParams.get("code") || null;
      const state = queryParams.get("state") || null;
      const error = queryParams.get("error") || null;
      const errorDesc = queryParams.get("error-description") || null;
      if ((code && state) || (error && state)) {
        var splitState = state.split("-");
        const identify = splitState[splitState.length - 1]

        switch (parseInt(identify)) {
          case DEVICE_TYPE.IOS:
            window.location = 'kimbocorp://' + location.search
            break;
          case DEVICE_TYPE.ANDRIOD:
            window.location = `kimbocorp://kimbocorp.com/` + location.search
            break;
          default:
            console.log("isLoggedIn", isLoggedIn)
            if (isLoggedIn) {
              console.log("Dashboard")
              window.location = RoutesPaths.DASHBOARD + location.search
            } else {
              console.log("MyInfoProcess")
              window.location = RoutesPaths.MYINFOPROCESS + location.search
            }
            break;
        }
      }
    } else {
      console.log("Dashboard")
      window.location = RoutesPaths.DASHBOARD
    }
  }, [dispatch, location]);

  return (
    <></>
  );
}
